import { Image, Text, View } from '@react-pdf/renderer';

import TamanLogo from '../../../assets/TamanLogo.png';
import { Project, Version } from '../../../types/project.ts';
import styles from './HeaderStyles.ts';

interface HeaderProps {
  project: Project;
  activeVersion: Version;
}

const Header = ({ project, activeVersion }: HeaderProps) => (
  <View style={styles.container} fixed>
    <View style={styles.spaceBetween}>
      <View style={styles.leftSection}>
        <View style={styles.leftSectionTitle}>
          <Text style={[styles.textBold, styles.textTruncate]}>{project.name}</Text>
          <Text>{activeVersion.name}</Text>
        </View>
        <View style={styles.leftSectionTitle}>
          <Text style={styles.textBold}>Beta user</Text>
          <Text>Client</Text>
        </View>
        <View style={styles.leftSectionTitle}>
          <Text style={styles.textBold}>Taman Technologies</Text>
          <Text>Performer</Text>
        </View>
      </View>
      <Image style={styles.logo} src={TamanLogo} />
    </View>
  </View>
);

export default Header;
